import React from 'react';

function SuccessCheckmark() {
	return (
		<div className="success-checkmark">
			<svg height="53px" width="53px" version="1.1" viewBox="0 0 53 53">
				<g id="Overlay-Selected-FF" fill="none" stroke="none" strokeWidth="1"
					transform="translate(-454.000000, -327.000000)">
					<g id="Group-2" transform="translate(454.000000, 174.000000)">
						<g id="Group" transform="translate(0.000000, 153.000000)">
							<circle id="Oval" cx="26.5" cy="26.5" fill="#FFFFFF"
								r="26.5"/>
							<g id="icSuccessLg" stroke="#00CF92" strokeLinecap="round" transform="translate(8.655087, 8.655087)">
								<path id="Page-1" d="M12.9474642,17.8170968 L17.3449132,22.2145458 L31.5118111,8.04799478 L31.5596887,8.01711723 C28.5208519,3.3955458 23.2893621,0.344913151 17.3449132,0.344913151 C7.95605601,0.344913151 0.344913151,7.95605601 0.344913151,17.3449132 C0.344913151,26.7337703 7.95605601,34.3449132 17.3449132,34.3449132 C26.7337703,34.3449132 34.3449132,26.7337703 34.3449132,17.3449132 C34.3449132,16.1302805 34.2175866,14.9454846 33.9754234,13.8030152"/>
							</g>
						</g>
					</g>
				</g>
			</svg>
		</div>
	)
}
export default SuccessCheckmark;



// WEBPACK FOOTER //
// ./components/successCheckmark/SuccessCheckmark.js